<template>
    <div class="home">
      <mHead :caseFun="caseInit"></mHead>
      <div class="main">
            <div class="videoBox" :style="{height: videoHeight+'px'}">
                <video loop :style="{height: videoHeight+'px'}" autoplay muted poster="" :src="homeObject.firstImg.url" preload="preload"></video>
                <div class="button" @click="showCooperate=true">
                    <span>合作咨询</span>
                </div>
            </div>
            <div class="caseBox">
                <div class="caseNav" ref="caseNav">
                    <ul>
                        <li v-for="(item,index) in homeObject.caseTypeList" :key="index" @click="changeType(item.id)">
                            <span :class="selectNav==item.navName?'on':''">{{item.navName}}</span>
                        </li>
                        <li>
                            <div class="input">
                                <input type="text" placeholder="黑电" v-model="searchKey" @blur="searchCase" placeholder-class="placeinput">
                                <img src="@/assets/img/Group 80-2@2x.png" alt="" @click="searchCase">
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="caseList" v-if="caseList.length">
                    <div class="caseItem">
                        <div class="item" v-for="item in caseList" :key="item.id" @click="toDetail(item.id)">
                            <img :src="item.imageUrl" alt="">
                            <div class="optg"></div>
                            <div class="info">
                                <p :title="item.caseName">{{item.caseName}}</p>
                                <p :title="item.remarks">{{item.remarks}}&nbsp;</p>
                                <span></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="nodata" v-else>
                    <p>暂无数据...</p>
                </div>
                <div class="pagination" v-if="pageNum > 1">
                    <span v-for="item in pageNum" :key="item" :class="selectNum == (item - 1)?'on':''" @click="changePage(item)">
                        {{item}}
                    </span>
                    <span class="last" v-if="pageNum > 2" @click="changePage(pageNum)"></span>
                </div>
            </div>
            <div class="partners">
                <p>
                    合作客户
                </p>
                <img :style="'display: block;'" :src="homeObject.bottomImg.url" alt="">
            </div>
            
            <!-- <div class="numDiv">
                <img :style="'height: ' + homeObject.bottomImg.height + 'px;'" :src="homeObject.bottomImg.url" alt="">
                <div class="content">
                    <div class="leftDiv">
                        <p>{{homeObject.leftWordTop}}<i></i></p>
                        <p>{{homeObject.leftWordBottom}}<i></i></p>
                    </div>
                    <div class="rightDiv">
                        <span class="num">
                            <countTo ref="count1" :separator="''" :startVal='0' :endVal='Number(homeObject.numberObject.firstValue || 0)' :duration='2000'></countTo>
                            <span class="plus">+</span>
                            <span class="desc">{{homeObject.numberObject.firstKey}}</span>
                        </span>
                        <span class="num">
                            <countTo ref="count2" :separator="''" :startVal='0' :endVal='Number(homeObject.numberObject.secondValue || 0)' :duration='2000'></countTo>
                            <span class="plus">+</span>
                            <span class="desc">{{homeObject.numberObject.secondKey}}</span>
                        </span>
                        <span class="num">
                            <countTo ref="count3" :startVal='0' :endVal='Number(homeObject.numberObject.thirdValue || 0)' :separator="''" :duration='2000'></countTo>
                            <span class="plus">+</span>
                            <span class="desc">{{homeObject.numberObject.thirdKey}}</span>
                        </span>
                    </div>
                </div>
                <div class="titlediv">
                    <span>{{homeObject.bottomWord}}<i></i></span>
                </div>
            </div> -->
           
        </div>
        <mBottom></mBottom>
        <div class="cooperate" v-show="showCooperate">
            <img class="close" src="@/assets/img/ic_guanbi-2@2x.png" alt="" @click="showCooperate=false;">
            <div class="content clear">
                <div class="left">
                    <h4>合作咨询</h4>
                    <div class="info">
                        <p class="address">
                            <img src="@/assets/img/Group 158@2x.png" alt="">
                            <span>{{homeObject.company.address}}</span>
                        </p>
                        <p class="phone">
                            <img src="@/assets/img/Group 159@2x.png" alt="">
                            <span>{{homeObject.company.phone}}</span>
                        </p>
                    </div>
                </div>
                <img class="right" :src="homeObject.company.url" alt="">
            </div>
        </div>
        <div :class="'back' + (showCooperate? ' show': '')" @click="showCooperate=false"></div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import mHead from '@/components/base/pc/mHead.vue'
import mBottom from '@/components/base/pc/mBottom.vue'
import {eventBus} from '@/utils/eventBus.js';
import countTo from 'vue-count-to';
export default {
    components:{mHead,mBottom,countTo},
    data() {
        return {
            isOk: false,
            showCooperate: false,
            homeObject: {
                firstImg: {url: ''},
                company: {
                    url: '',
                    phone: '',
                    address: ''
                },
                imgList: [],
                leftWordTop: '',
                leftWordBottom: '',
                numberObject: {
                    firstKey: '',
                    firstValue: '',
                    secondKey: '',
                    secondValue: '',
                    thirdKey: '',
                    thirdValue: ''
                },
                bottomWord: '',
                bottomImg: {
                    url: ''
                },
                caseTypeList: []
            },
            videoHeight: 700,
            selectNav: '',
            caseList: [],
            allCacsList: [],
            pageNum: 0,
            selectNum: 0,
            searchKey: ''
        }
    },
    computed: mapState({
    // 映射 this.count 为 store.state.count
       
        // swiper() {
        //     return this.$refs.mySwiper.swiper
        // },
    }),
    mounted(){
        this.getList();
        this.statistics();
        this.videoHeight = 700/1920*document.body.scrollWidth
        // console.log(a.toString())
        this.$nextTick(()=>{
            window.addEventListener('resize', this.resizeFun);
        })
        
    },
    beforeDestroy(){
        // window.removeEventListener('scroll', this.handleScroll, false);
        window.removeEventListener('resize', this.resizeFun, false);
    },
    methods: {
        toDetail(id){
            this.$router.push('/detail/'+id)
        },
        caseInit(){
            window.scrollTo({
                top: this.$refs.caseNav.offsetTop - 100,
                behavior: 'smooth'
            })
        },
        resizeFun(){
            this.videoHeight = 700/1920*document.body.scrollWidth
        },
        handleScroll(e) {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            let screenHeight = window.screen.height;
            let titleTop = document.getElementsByClassName('numDiv')[0].offsetTop;
            if(((scrollTop + screenHeight - titleTop) > -20) && !this.isOk) {
                this.isOk = true;
                this.$refs.count1.start();
                this.$refs.count2.start();
                this.$refs.count3.start();
            }
            if((scrollTop + screenHeight - titleTop) < 0){
                this.isOk = false;
            }
        },
        statistics(){
            this.$http.post(this.service.dev.api.statistics, {pageName: '首页'} ).then(response =>{
              
            })
        },
        getList(){
            this.$http.get(this.service.dev.api.recommendList+'?pageId=1' ).then(response =>{
              if(response.status == 200){
                this.recommendList = response.body || []
                this.formatData(response.body || [])
                setTimeout(() => {
                    let name = this.$route.name;
                    if(name == 'case') {
                        this.caseInit();
                    }
                }, 500);
                //   setTimeout(() => {
                //       window.addEventListener('scroll',this.handleScroll) 
                //   }, 500);
              } else {
                  this.$message.error(response.message?response.message:'error');
              }
            }).catch((res)=>{
                this.$message.error('error');
            })
        },
        formatData(list){
            list.map(item => {
                if(item.keyName == 'firstUrl') {
                    this.homeObject.firstImg.url = item.content;
                    this.homeObject.firstImg.height = item.keyDesc;
                } else if(item.keyName == 'company') {
                    let company = JSON.parse(item.content)
                    this.homeObject.company.url = company.url;
                    this.homeObject.company.phone = company.phone;
                    this.homeObject.company.address = company.address;
                }
                //  else if (item.keyName == 'imgList') {
                //     let heightList = item.keyDesc.split(',');
                //     let urlList = item.content.split(',');
                //     this.homeObject.imgList = [];
                //     urlList.map((em,ind) => {
                //         this.homeObject.imgList.push({ height: heightList[ind], url: em})
                //     })
                // } else if (item.keyName == 'leftWordTop') {
                //     this.homeObject.leftWordTop = item.content;
                // } else if (item.keyName == 'leftWordBottom') {
                //     this.homeObject.leftWordBottom = item.content;
                // } else if (item.keyName == 'firstKey') {
                //     this.homeObject.numberObject.firstKey = item.content;
                //     this.homeObject.numberObject.firstValue = item.keyDesc;
                // } else if (item.keyName == 'secondKey') {
                //     this.homeObject.numberObject.secondKey = item.content;
                //     this.homeObject.numberObject.secondValue = item.keyDesc;
                // } else if (item.keyName == 'thirdKey') {
                //     this.homeObject.numberObject.thirdKey = item.content;
                //     this.homeObject.numberObject.thirdValue = item.keyDesc;
                // } else if (item.keyName == 'bottomWord') {
                //     this.homeObject.bottomWord = item.content;
                // } 
                else if(item.keyName == 'bottomImg') {
                    this.homeObject.bottomImg.url = item.content;
                    this.homeObject.bottomImg.height = item.keyDesc;
                }else if(item.keyName == 'caseTypeList') {
                    this.homeObject.caseTypeList.push({id: item.id, navName: item.keyDesc, caseList: item.caseArray});
                }
            })
            if(this.homeObject.caseTypeList.length){
                this.selectNav = this.homeObject.caseTypeList[0].navName;
                this.caseList = this.homeObject.caseTypeList[0].caseList.slice(0,9);
                this.pageNum = Math.ceil(this.homeObject.caseTypeList[0].caseList.length/9);
                this.allCacsList = this.homeObject.caseTypeList[0].caseList || [] ;
            }
        },
        searchCase(){
            this.selectNum = 0;
            if(this.searchKey){
                let caseList  = this.allCacsList.filter(item => {
                    return item.caseName.indexOf(this.searchKey)>-1
                })
                this.caseList = caseList.slice(0,9)
                this.pageNum = Math.ceil(caseList.length/9);
            } else {
                this.caseList = this.allCacsList.slice(0,9);
                this.pageNum = Math.ceil(this.allCacsList.length/9);
            }
        },
        changeType(id) {
            let caseType = {};
            this.homeObject.caseTypeList.map(item =>{
                if(id == item.id) {
                    caseType = item;
                }
            })
            this.selectNav = caseType.navName || '';
            this.caseList = caseType.caseList.slice(0,9) || [];
            this.allCacsList = caseType.caseList || [] ;
            this.pageNum = Math.ceil(caseType.caseList.length/9) || 0;
            this.selectNum = 0;
        },
        changePage(num) {
            this.selectNum = num - 1;
            if(this.searchKey){
                this.caseList = this.allCacsList.filter(item =>{
                    return item.caseName.indexOf(this.searchKey)>-1
                }).slice(this.selectNum*9,this.selectNum*9+9)
            } else {
                this.caseList = this.allCacsList.slice(this.selectNum*9,this.selectNum*9+9)
            }
            window.scrollTo({
                top: this.$refs.caseNav.offsetTop - 100,
                behavior: 'smooth'
            })
            
            // this.homeObject.caseTypeList.map(item=>{
            //     if(item.navName == this.selectNav){
            //         this.caseList = item.caseList.slice(0,9) || [];
            //     }
            // })
        }
    }
}
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1440px){
    .home{
        .caseBox {
            .caseList {
                width: 1080px;
                min-width: 1000px;
            }
        }
        .partners {
            img {
                width: 75%;
            }
        }
    }
}
@media screen and (min-width: 1440px) and (max-width: 1920px){
    .home{
        .caseBox {
            .caseList {
                width: 75%;
                min-width: 1000px;
            }
        }
        .partners {
            img {
                width: 75%;
            }
        }
    }
}
@media screen and (min-width:1920px) {
    .home{
        .caseBox {
            .caseList {
                width: 1440px;
            }
        }
        .partners {
            img {
                width: 1440px;
            }
        }
    }
}
    .home {
        min-width: 1080px;
        position: relative;
        .main {
            overflow: hidden;
            .videoBox {
                width: 100%;
                position: relative;
                text-align: center;
                video {
                    width: 100%;
                }
                video::-webkit-media-contorls-timeline {
                    display: none;
                }
                video::-webkit-media-contorls-toggle-closed-captions-botton {
                    display: none;
                }
                video::-ms-media-contorls-timeline {
                    display: none;
                }
                video::-ms-media-contorls-toggle-closed-captions-botton {
                    display: none;
                }
                .button {
                    position: absolute;
                    bottom: 8%;
                    left: calc(50% - 82px);
                    width: 164px;
                    height: 42px;
                    cursor: pointer;
                    border: 1px solid #ffffff;
                    &:hover {
                        background: #ffffff;
                        span {
                            color: #000000;
                        }
                    }
                    span {
                        font-size: 14px;
                        color: #ffffff;
                        line-height: 42px;
                    }
                }
            }
            .caseBox {
                background: #000000;
                padding-top: 80px;
                .caseNav {
                    height: 36px;
                    margin-bottom: 70px;
                    ul {
                        margin: 0px; 
                        height: 100%;
                        padding: 0;
                        display: flex;
                        justify-content: center;
                        >li {
                            height: 100%;
                            float: left;
                            list-style: none;
                            
                            font-size: 16px;
                            cursor: pointer;
                            display: flex;             /*flex弹性布局*/
                            // justify-content: center;
                            align-items: center;
                            padding: 0px 34px;
                            &:first-child {
                                padding-left: 0;
                            }
                            &:hover span {
                                color: rgba(255, 255, 255, 1);
                                opacity: 1;
                            }
                            span {
                                display: inline-block;
                                line-height: 36px;
                                color: rgba(255, 255, 255, 0.60);
                                opacity: 0.5;
                                &.on {
                                    color: rgba(255, 255, 255, 1);
                                    opacity: 1;
                                }
                            } 
                            .input {
                                height: 34px;
                                border: 1px solid rgba(255, 255, 255, 0.2);
                                box-sizing: border-box;
                                position: relative;
                                text-align: left;
                                input {
                                    border: 0;
                                    background: inherit;
                                    width: calc(100% - 48px);
                                    margin-left:12px;
                                    height: calc(100% - 16px);
                                    margin-top: 7px;
                                    font-size: 16px;
                                    color: rgba(255, 255, 255, 1);
                                    &:focus{
                                        outline: none;
                                        border: none;
                                    }
                                }
                                input::input-placeholder {
                                    font-size: 16px;
                                    color: rgba(255,255,255,0.2);
                                }
                                input::-webkit-input-placeholder {
                                    font-size: 16px;
                                    color: rgba(255,255,255,0.2);
                                }
                                input::-moz-input-placeholder {
                                    font-size: 16px;
                                    color: rgba(255,255,255,0.2);
                                }
                                input::-ms-input-placeholder {
                                    font-size: 16px;
                                    color: rgba(255,255,255,0.2);
                                }
                                .placeinput {
                                    font-size: 16px;
                                    color: rgba(255,255,255,0.2);
                                }
                                img {
                                    position: absolute;
                                    right: 12px;
                                    top: 10px;
                                    width: 12px;
                                    height: 12px;
                                    cursor: pointer;
                                }
                            }
                        }
                    }
                }
                .nodata {
                    p {
                        font-size: 18px;
                        text-align: center;
                        padding-bottom: 70px;
                        color: rgba(255,255,255,0.4);
                    }
                }
                .caseList {
                    // width: 1440px;
                    margin: 0px auto 0px;
                    text-align: left;
                    .item {
                        display: inline-block;
                        width: 30%;
                        margin-bottom: 79px;
                        cursor: pointer;
                        position: relative;
                        .optg {
                            position: absolute;
                            top: 0;
                            left: 0;
                            right: 0;
                            bottom: 0;
                            background: rgba(0,0,0,0.3);
                        }
                        &:hover {
                            .optg {
                                display: none;
                            }
                        }
                        &:nth-child(3n) {
                            margin-left: 5%;
                        }
                        &:nth-child(3n+1) {
                            margin-right: 5%;
                        }
                        img{
                            width: 100%;
                            // height: 319px;
                            margin-bottom: 24px;
                            display: block;
                        }
                        .info {
                            position: relative;
                            height: 48px;
                            display: inline-block;
                            width: 100%;
                            p {
                                text-align: left;
                                &:first-child {
                                    font-size: 16px;
                                    color: #ffffff;
                                    width: calc(100% - 50px);
                                    overflow: hidden;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                    margin-bottom: 6px;
                                }
                                &:nth-child(2) {
                                    font-size: 14px;
                                    color: rgba(255, 255, 255, 0.4);
                                    width: calc(100% - 50px);
                                    overflow: hidden;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;

                                }
                            }
                            span {
                                display: inline-block;
                                position: absolute;
                                width: 36px;
                                height: 36px;
                                right: 0px;
                                top: 4px;
                                color: rgba(255, 255, 255, 0.6);
                                border: 1px solid rgba(255, 255, 255, 0.1);
                                text-align: center;
                                line-height: 36px;
                                &:after {
                                    content: '';
                                    display: inline-block;
                                    width: 10px;
                                    height: 10px;
                                    border: 1px solid rgba(255, 255, 255, 0.6);
                                    border-bottom: none;
                                    border-left: none;
                                    transform: rotate(45deg);
                                    margin-right: 5px;
                                }
                            }
                        } 
                        
                    }
                }
                .pagination {
                    padding-bottom: 80px;
                    span {
                        display: inline-block;
                        width: 36px;
                        height: 36px;
                        color: rgba(255, 255, 255, 0.2);
                        background: rgba(255, 255, 255, 0.05);
                        line-height: 36px;
                        margin-right: 1px;
                        font-size: 16px;
                        cursor: pointer;
                        &.on {
                            color: rgba(255, 255, 255, 0.8);
                        }
                        &:hover {
                            color: rgba(255, 255, 255, 0.8);
                        }
                        &.last {
                            margin-left: -4px;
                            &:after {
                                content: '';
                                display: inline-block;
                                width: 8px;
                                height: 8px;
                                border: 1px solid rgba(255, 255, 255, 0.6);
                                border-bottom: none;
                                border-left: none;
                                transform: rotate(45deg) translateY(-2px);
                                margin-right: 5px;
                            }
                            &:hover {
                                &:after { 
                                    border-color: rgba(255, 255, 255, 0.8);
                                }
                            }
                        }
                    }
                }
            }
            .partners {
                padding-top: 80px;
                background: #000000;
                padding-bottom: 80px;
                border-top: 1px solid rgba(255,255,255,0.05);
                P {
                    font-size: 30PX;
                    color: #ffffff;
                    text-align: center;
                    margin-bottom: 37px;
                }
                img {
                    margin: 0 auto;
                }
            }
            .numDiv {
                background: #0b0605;
                width: 100%;
                position: relative;
                >img {
                    width: 100%;
                    position: absolute;
                    object-fit: none;
                    display: block;
                    top:0;
                    z-index: 0;
                }
                .content {
                    margin: 0 auto;
                    color: #ffffff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: relative;
                    z-index: 1;
                    >div {
                        // display: inline-block;
                    }
                    .leftDiv {
                        margin-right: 50px; 
                        p {
                            text-align: justify;
                            color: #F58232;
                            font-size: 26px;
                            width: 180px;
                            height: 36px;
                            font-family: SourceHanSansCN-Bold;
                            &:last-child {
                                font-size: 20px;
                                color: #ffffff;
                                font-family: SourceHanSansCN-Medium;
                            }
                            i {
                                display:inline-block;
                                width:100%;
                            }
                        }
                    }
                    .rightDiv {
                        position: relative;
                        .num {
                            font-family: SourceHanSansCN-Medium;
                            font-size: 69px;
                            position: relative;
                            margin-right: 2px;
                            // &:last-child {
                            //     margin-right: 0;
                            // }
                        }
                        .plus {
                            position: relative;
                            top: -42px;
                            right: 10px;
                            font-size: 20px;
                        }
                        .plus,.desc {
                            font-family: SourceHanSansCN-Normal;
                        }
                        .desc {
                            font-size: 12px;
                            position: relative;
                            // width: 100px;
                            color: #F58232;
                            top: -30px;
                            right: 38px;
                        }
                    }
                }
                .titlediv {
                    color: #F58232;
                    font-size: 26px;
                    font-family: SourceHanSansCN-Regular;
                    padding-bottom: 10px;
                    margin-top: 24px;
                    span {
                        position: relative;
                        display: inline-block;
                        width: 410px;
                        text-align: justify;
                        height: 30px;
                        &::after {
                            content: " ";
                            position: absolute;
                            left: -8px;
                            right: -8px;
                            bottom: -22px;
                            height: 2px;
                            // border-top: 1px solid #F58232;
                            color: #F58232;
                            background: #F58232;
                        }
                        i {
                            display:inline-block;
                            width:100%;
                        }
                    }
                }
            }
        }
    }

    .back {
        position: fixed;
        top: 52px;
        left: 0;
        right: 0;
        bottom: 0;
        // background: rgba(0,0,0,0.9);
        z-index: 96;
        background: rgba(232,232,237,.4);
        -webkit-backdrop-filter: blur(20px);
        backdrop-filter: blur(20px);
        visibility: hidden;
        opacity: 0;
        transition: opacity .32s cubic-bezier(.4,0,.6,1) 80ms,visibility .32s step-end 80ms;
        &.show {
            visibility: visible;
            opacity: 1;
            transition: opacity .32s cubic-bezier(.4,0,.6,1) 80ms,visibility .32s step-start 80ms;
        }
    }
    .cooperate {
        width: 960px;
        height: 527px;
        margin: 0 auto;
        position: fixed;
        top: 160px;
        left: 50%;
        transform: translateX(-480px);
        z-index: 97;
        .close {
            position: absolute;
            right: 0;
            top: 0;
            width: 48px;
            height: 48px;
            cursor: pointer;
        }
        .content {
            height: 100%;
            width: 100%;
            background: #ffffff;
            .left {
                padding: 40px;
                position: relative;
                height: 100%;
                width: 430px;
                box-sizing: border-box;
                h4 {
                    font-size: 36px;
                    position: relative;
                    margin: 0;
                    text-align: left;
                    &:after {
                        content: "";
                        position: absolute;
                        left: 0;
                        bottom: -20px;
                        width: 70px;
                        height: 2px;
                        background-color: #000;
                        z-index: 2;
                    }
                }
                .info {
                    position: absolute;
                    bottom: 40px;
                    left: 40px;
                    .address,.phone {
                        text-align: left;
                        display: flex;
                        justify-content: flex-start;
                        align-items: flex-start;
                        &:first-child {
                            margin-bottom: 4px;
                        }
                        img {
                            width: 24px;
                            height: 24px;
                        }
                        span {
                            font-size: 16px;
                            color: rgba(0,0,0,0.6);
                            // vertical-align: super;
                            margin-left: 8px;
                        }
                    }
                }
            }
            .right {
                width: 530px;
                height: 100%;
            }
        }
    }
</style>
<style lang="scss">
   
</style>





// WEBPACK FOOTER //
// src/modules/view/home/index.vue